import PropTypes from 'prop-types';

const displayName = 'ModalConfirm';

const propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  desc: PropTypes.string,
  btn: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

const defaultProps = {
  visible: false,
};

export default { displayName, propTypes, defaultProps };
